import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/observable/forkJoin';
import * as emiGlobals from 'app/globals';
import { CanActivate, CanActivateChild, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { AuthService } from "app/auth/auth.service";
import { EmiBaseInfoService } from "app/shared/services/emi-base-info.service";

export class PortalInfo{
  public portalInfo;
  public menu;
  public city;
}

@Injectable()
export class EmiDataService {
  direction:any;
  private headers: Headers ;
  private token;
  private options: RequestOptions ;

  constructor(
    private _http:Http,
    private authService:AuthService,
    private baseInfoService:EmiBaseInfoService
  ) {
   }

   setHeaderOptions(){
     

     this.token =  localStorage.getItem('id_token');
     if(this.token==null){
      this.authService.getJwtToken().map(response => {
        return  response.json();
      }).subscribe(tokenData=>{
        localStorage.setItem('id_token',tokenData.token);
      });
      this.token =  localStorage.getItem('id_token');
      console.log("EmiDataService id_token ", this.token);
      
     }
     
     this.headers= new Headers( {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin':'*',
        'Access-Control-Allow-Headers': 'Content-Type',
      }); 
     this.headers.append('Authorization','Bearer '+this.token);
     this.options = new RequestOptions ({ headers: this.headers} );   
        
   }

  getBasicLoadingDatas():Observable<PortalInfo>{
    this.setHeaderOptions();
    return this._http.get(emiGlobals.portalInfoUrl,this.options).map(res => res.json());
  }

  getHomePageDatas():Observable<any>{
    this.setHeaderOptions();

    let apiResponseData = {};
    let UrlData = JSON.parse('{ "url":"/"}');

    let params: URLSearchParams = new URLSearchParams();
        Object.assign(params, UrlData);
        console.log("getPageInfoByUrl params",params);

    let pageInfoByUrl_options = new RequestOptions ({ headers: this.headers, search:params} );

    return Observable.forkJoin([
      //this._http.get(emiGlobals.portalInfoUrl,this.options).map(res => res.json()),
      this._http.get(emiGlobals.pageInfoByUrl,pageInfoByUrl_options).map(res => res.json()),
      this._http.get(emiGlobals.homeProductsList, this.options).map(res => res.json())
    ])
    .map((data: any[]) => {
      this.updatePageInfo(data[0]);
      //apiResponseData['portalInfo']       = data[0];
      apiResponseData['pageInfo']         = data[0];
      apiResponseData['homeProducts']     = data[1];
      return apiResponseData;
    });
  }


  getHomeLoanPageDatas(url):Observable<any>{
    this.setHeaderOptions();
    let apiResponseData = {};
    let UrlData = JSON.parse('{ "url":"'+url+'"}');

    let params: URLSearchParams = new URLSearchParams();
        Object.assign(params, UrlData);
        console.log("getPageInfoByUrl params",params);

    let pageInfoByUrl_options = new RequestOptions ({ headers: this.headers, search:params} );

    return Observable.forkJoin([
      //this._http.get(emiGlobals.portalInfoUrl,this.options).map(res => res.json()),
      this._http.get(emiGlobals.pageInfoByUrl,pageInfoByUrl_options).map(res => res.json()),
    ])
    .map((data: any[]) => {
      this.updatePageInfo(data[0]);
      apiResponseData['pageInfo']         = data[0];
      return apiResponseData;
    });
  }

  getPersonalLoanPageDatas(url):Observable<any>{
    this.setHeaderOptions();
    let apiResponseData = {};
    let UrlData = JSON.parse('{ "url":"'+url+'"}');

    let params: URLSearchParams = new URLSearchParams();
        Object.assign(params, UrlData);
        console.log("getPageInfoByUrl params",params);

    let pageInfoByUrl_options = new RequestOptions ({ headers: this.headers, search:params} );

    return Observable.forkJoin([
      //this._http.get(emiGlobals.portalInfoUrl,this.options).map(res => res.json()),
      this._http.get(emiGlobals.pageInfoByUrl,pageInfoByUrl_options).map(res => res.json()),
    ])
    .map((data: any[]) => {
      this.updatePageInfo(data[0]);
      //apiResponseData['portalInfo']       = data[0];
      apiResponseData['pageInfo']         = data[0];
      return apiResponseData;
    });
  }

  
  getInsurancePageDatas(url,insurance_type):Observable<any>{
    this.setHeaderOptions();
    let apiResponseData = {};
    let UrlData = JSON.parse('{ "url":"'+url+'"}');

    let params: URLSearchParams = new URLSearchParams();
        Object.assign(params, UrlData);
        console.log("getPageInfoByUrl params",params);
    let insuranceProductsUrl = emiGlobals.insuranceProductsUrl+insurance_type;
    let pageInfoByUrl_options = new RequestOptions ({ headers: this.headers, search:params} );

    return Observable.forkJoin([
      //this._http.get(emiGlobals.portalInfoUrl,this.options).map(res => res.json()),
      this._http.get(emiGlobals.pageInfoByUrl,pageInfoByUrl_options).map(res => res.json()),
      this._http.get(insuranceProductsUrl,this.options).map(res => res.json()),

    ])
    .map((data: any[]) => {
      this.updatePageInfo(data[0]);
      //apiResponseData['portalInfo']       = data[0];
      apiResponseData['pageInfo']         = data[0];
      apiResponseData['products']         = data[1];
      apiResponseData['type']             = insurance_type;
      return apiResponseData;
    });
  }

  //Savesalary
  getSavesalaryPageDatas(url){
    this.setHeaderOptions();
    let apiResponseData = {};
    let UrlData = JSON.parse('{ "url":"'+url+'"}');

    let params: URLSearchParams = new URLSearchParams();
        Object.assign(params, UrlData);

    let pageInfoByUrl_options = new RequestOptions ({ headers: this.headers, search:params} );

    return Observable.forkJoin([
      this._http.get(emiGlobals.pageInfoByUrl,pageInfoByUrl_options).map(res => res.json()),
    ])
    .map((data: any[]) => {
      this.updatePageInfo(data[0]);
      apiResponseData['pageInfo']         = data[0];
      return apiResponseData;
    });
  }

  //Products
  getPageData(url){
    this.setHeaderOptions();

    let apiResponseData = {};
    let UrlData = JSON.parse('{ "url":"/product/'+url+'"}');

    let params: URLSearchParams = new URLSearchParams();
        Object.assign(params, UrlData);
        console.log("getPageInfoByUrl params",params);

    let pageInfoByUrl_options = new RequestOptions ({ headers: this.headers, search:params} );

    return Observable.forkJoin([
      this._http.get(emiGlobals.pageInfoByUrl,pageInfoByUrl_options).map(res => res.json()),
      this._http.get(emiGlobals.productListByUrl,pageInfoByUrl_options).map(res => res.json())
    ])
    .map((data: any[]) => {
      this.updatePageInfo(data[0]);
      apiResponseData['pageInfo']         = data[0];
       apiResponseData['products']         = data[1];
      return apiResponseData;
    });
  }
  getProductData(url) {
    this.setHeaderOptions();
    const UrlData = JSON.parse('{ "url":"/calculator/' + url + '"}');
    const params: URLSearchParams = new URLSearchParams();
        Object.assign(params, UrlData);
    // let pageInfoByUrl_options = new RequestOptions ({ headers: this.headers, search:params} );

    // return Observable.forkJoin([
    //   this._http.get(emiGlobals.pageInfoByUrl,pageInfoByUrl_options).map(res => res.json()),
    //   this._http.get(emiGlobals.productListByUrl,pageInfoByUrl_options).map(res => res.json())
    // ])
    // .map((data: any[]) => {
    //   this.updatePageInfo(data[0]);
    //   apiResponseData['pageInfo']         = data[0];
    //    apiResponseData['products']         = data[1];
    //   return apiResponseData;
    // });
  }




  // updateLocalData(result_portalInfo,result_pageInfo){
  //   this.baseInfoService.updateLocalData(emiGlobals.portalInfo,result_portalInfo.portalInfo);
  //   this.baseInfoService.updateLocalData(emiGlobals.pageInfo,result_pageInfo.pageInfo);
  //   this.baseInfoService.updateLocalData(emiGlobals.agentInfo,result_pageInfo.pageInfo.conact_agent);
  //   this.baseInfoService.updateLocalData(emiGlobals.pageTestimonials,result_pageInfo.testimonial);
  //   this.baseInfoService.announcePageDataFetched("fetched");
  // }
  updatePageInfo(result_pageInfo){
    this.baseInfoService.updateLocalData(emiGlobals.pageInfo,result_pageInfo.pageInfo);
    this.baseInfoService.updateLocalData(emiGlobals.agentInfo,result_pageInfo.pageInfo.conact_agent);
    this.baseInfoService.updateLocalData(emiGlobals.pageTestimonials,result_pageInfo.testimonial);
    this.baseInfoService.announcePageDataFetched("fetched");
  }

}



@Injectable()
export class CanActivateViaEmiTokenGuard implements  CanActivate, CanActivateChild {

  constructor(
    private authService: AuthService,
    private emiDataService:EmiDataService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url: string = state.url;
    console.log('checking route access');
    return this.checkToken(url);
    
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let url: string = state.url;
    console.log('checking route child access');
    return this.checkToken(url);
    
  }

  checkToken(url){
    console.log(this.authService.isInvalidJwtToken());
    if(this.authService.isInvalidJwtToken()){
      this.authService.redirectUrl = url;
      if(url=='/'){
        if(localStorage.getItem('portalInfo')!=null){
          let portalinfo = JSON.parse(localStorage.getItem('portalInfo'));
          url = portalinfo.default_url;
        }
      }
      // Navigate to the loading page with extras
      this.router.navigate(['/loading']);
      return false;
    }else{
      //this.emiDataService.getBasicLoadingDatas();
      if(url=='/'){
        if(localStorage.getItem('portalInfo')!=null){
          let portalinfo = JSON.parse(localStorage.getItem('portalInfo'));
          if(portalinfo.default_url!='/'){
            this.router.navigate([portalinfo.default_url]);
          }
        }
      }
      return true;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/emi-data.service.ts